import React from 'react';

const PageTitle = ({pageTitle}) => { 
    return ( 
        <div className="primary-text-color secondary-normal-font font-size-30">{pageTitle}</div>
    )
}

export default PageTitle